import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { fetchPacks, fetchWidgets } from '../actions';
import { Link } from 'react-router';
import CreateDialog from './CreateDialog';
import { Card, CardHeader } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import IconPacks from 'material-ui/svg-icons/action/view-week';
import { indigo500, grey300 } from 'material-ui/styles/colors';

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Title = styled.h2`
    flex-grow: 1;
    color: ${indigo500};
    font-weight: inherit;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const ButtonWrapper = styled.div`
    display: inline-block;
    text-align: right;

    button {
        color: #fff;
    }

    > * + * {
        margin-left: 20px;
    }
`;

const ErrorText = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: red;
`;

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0
};

const IconPacksStyle = {
    color: 'inherit'
};

const CardStyle = {
    marginBottom: 15
};

class PacksScene extends PureComponent {
    state = {
        createDialogOpen: false
    };

    componentDidMount() {
        this.props.fetchPacks();
        this.props.fetchWidgets();
    }

    toggleCreateDialog = () => this.setState(state => ({ createDialogOpen: !state.createDialogOpen }));

    render() {
        const { createDialogOpen } = this.state;
        const {
            children,
            isFinishedPacks = false,
            isFinishedWidgets = false,
            responseStatusWidgets = 0,
            responseStatusPacks = 0
        } = this.props;
        const error = responseStatusWidgets !== 200 || responseStatusPacks !== 200;
        const isFinished = isFinishedPacks && isFinishedWidgets;

        return (
            <div>
                <Card style={CardStyle}>
                    <CardHeader style={CardHeaderStyle}>
                        <HeaderWrapper>
                            <Title>
                                <IconPacks style={IconPacksStyle} />Packs Dashboard for Admin
                            </Title>
                            <ButtonWrapper>
                                <Link to="/admin/users-packs">
                                    <RaisedButton disabled={this.state.saving} label={"Manage user's packs"} />
                                </Link>
                                <RaisedButton onTouchTap={this.toggleCreateDialog} secondary labelColor="#fff">
                                    Create
                                </RaisedButton>
                            </ButtonWrapper>
                        </HeaderWrapper>
                    </CardHeader>
                    {!isFinished && (
                        <Loader>
                            <CircularProgress size={80} thickness={5} />
                        </Loader>
                    )}
                    {isFinished &&
                        error && (
                            <ErrorText>An error occurred while saving, refresh the page, or try again later!</ErrorText>
                        )}
                    {isFinished && !error && children}
                </Card>
                <CreateDialog isOpen={createDialogOpen} toggleCreateDialog={this.toggleCreateDialog} />
            </div>
        );
    }
}

PacksScene.propTypes = {
    children: PropTypes.element.isRequired,
    // From connect
    fetchPacks: PropTypes.func.isRequired,
    fetchWidgets: PropTypes.func.isRequired,
    isFinishedWidgets: PropTypes.bool.isRequired,
    isFinishedPacks: PropTypes.bool.isRequired,
    responseStatusWidgets: PropTypes.number.isRequired,
    responseStatusPacks: PropTypes.number.isRequired
};

export default connect(
    ({
        requery = {
            queries: {}
        }
    }) => ({
        isFinishedWidgets: get(requery.queries, ['GET:widgets', 'isFinished'], false),
        isFinishedPacks: get(requery.queries, ['GET:packs', 'isFinished'], false),
        responseStatusWidgets: get(requery.queries, ['GET:widgets', 'status'], 0),
        responseStatusPacks: get(requery.queries, ['GET:packs', 'status'], 0)
    }),
    { fetchPacks, fetchWidgets }
)(PacksScene);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/PacksScene.js
 **/